import FormValidator from "./modules/forms";

const form = new FormValidator();
